document.querySelectorAll('.ritual-lineup').forEach((section) => {
  const revealEls = section.querySelectorAll('[data-reveal], [data-reveal-stagger]');

  if (revealEls.length) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    revealEls.forEach((el) => observer.observe(el));
  }

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;

  const maxTilt = 8;

  section.querySelectorAll('.ritual-lineup__card').forEach((card) => {
    const tilt = card.querySelector('.ritual-lineup__tilt');
    if (!tilt) return;

    card.addEventListener('mousemove', (event) => {
      const rect = card.getBoundingClientRect();
      const x = (event.clientX - rect.left) / rect.width;
      const y = (event.clientY - rect.top) / rect.height;
      const tiltY = (x - 0.5) * 2 * maxTilt;
      const tiltX = (0.5 - y) * 2 * maxTilt;
      tilt.style.setProperty('--tilt-x', tiltX + 'deg');
      tilt.style.setProperty('--tilt-y', tiltY + 'deg');
    });

    card.addEventListener('mouseleave', () => {
      tilt.style.setProperty('--tilt-x', '0deg');
      tilt.style.setProperty('--tilt-y', '0deg');
    });
  });
});
